module.exports = __webpack_public_path__ + "img/PDAC1_Mast.e174dc18.png";